import { SplitPanel } from './split-panel';

export interface Layout extends SplitPanel {
  name: string;
}
